import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchUserNotifications = createAsyncThunk(
  "userNotification/fetchAll",
  async ({ page = 1, limit = 10, search = "" }, thunkAPI) => {
    try {
      const res = await api.get(`/api/userNotification?page=${page}&limit=${limit}&search=${search}`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch user notifications");
    }
  }
);

export const createUserNotification = createAsyncThunk(
  "userNotification/create",
  async (data, thunkAPI) => {
    try {
      const res = await api.post("/api/userNotification", data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to create");
    }
  }
);

export const updateUserNotification = createAsyncThunk(
  "userNotification/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await api.put(`/api/userNotification/${id}`, data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Failed to update");
    }
  }
);

export const toggleUserNotificationStatus = createAsyncThunk(
  "userNotification/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(`/api/userNotification/${id}/status`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

export const deleteUserNotification = createAsyncThunk(
  "userNotification/delete",
  async (id, thunkAPI) => {
    try {
      await api.delete(`/api/userNotification/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Delete failed");
    }
  }
);

const userNotificationSlice = createSlice({
  name: "userNotification",
  initialState: {
    notifications: [],
    loading: false,
    error: null,
    pagination: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserNotifications.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUserNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchUserNotifications.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(createUserNotification.fulfilled, (state) => {
        state.pagination.total = (state.pagination.total || 0) + 1;
      })
      .addCase(createUserNotification.rejected, (state, action) => { state.error = action.payload; })

      .addCase(updateUserNotification.fulfilled, (state, action) => {
        const index = state.notifications.findIndex((n) => n._id === action.payload._id);
        if (index !== -1) state.notifications[index] = action.payload;
      })
      .addCase(updateUserNotification.rejected, (state, action) => { state.error = action.payload; })

      .addCase(toggleUserNotificationStatus.fulfilled, (state, action) => {
        const index = state.notifications.findIndex((n) => n._id === action.payload._id);
        if (index !== -1) state.notifications[index] = action.payload;
      })

      .addCase(deleteUserNotification.fulfilled, (state) => {
        state.pagination.total = (state.pagination.total || 1) - 1;
      })
      .addCase(deleteUserNotification.rejected, (state, action) => { state.error = action.payload; });
  },
});

export default userNotificationSlice.reducer;